import * as z from "zod";

export const VehicleStatusEnum = z.enum([
  "active",
  "maintenance",
  "retired",
  "standby",
  "decommissioned",
]);

export const VehicleSchema = z.object({
  id: z.string().uuid(),
  type_id: z.string().uuid(),
  company_id: z.string().uuid(),
  fleet_number: z.string().min(1).max(100),
  status: VehicleStatusEnum.default("active"),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createVehicleSchema = VehicleSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateVehicleSchema = VehicleSchema.pick({
  fleet_number: true,
  status: true,
  type_id: true,
}).partial();

export const bulkUpdateVehicleStatusSchema = z.object({
  vehicle_ids: z
    .array(z.string().uuid())
    .min(1, "At least one vehicle must be selected"),
  status: VehicleStatusEnum,
});

export const assignVehicleTypeSchema = z.object({
  vehicle_id: z.string().uuid(),
  type_id: z.string().uuid(),
});
